<template>
    <div>
        <panel :title="$t('str.table.list.clients')" bodyClass="p-0">
            <div class="row ms-2 mb-1 mt-3 me-1">
                <div v-if="isSuperAdminMaster" class="col-md-4 mb-3">
                    <label class="form-label" for="accountField">{{ $t('str.register.client.account.field') }}</label>
                    <select v-model="filters.account" @change="filterFromFirstPage" class="form-select" id="accountField">
                        <option value="">{{ $t('str.register.select.placeholder') }}</option>
                        <option v-for="account in accounts" :value="account._id" :key="account._id">
                            {{ account?.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label class="form-label" for="statusField">{{ $t('str.register.status.field') }}</label>
                    <select v-model="filters.status" @change="filterFromFirstPage" class="form-select" id="statusField">
                        <option value="ACTIVE">{{ $t('str.register.status.active') }}</option>
                        <option value="ARCHIVED">{{ $t('str.register.status.archived') }}</option>
                    </select>
                </div>
                <div v-if="canCreateClient" class="col-md-4 text-end mt-2">
                    <button @click="selectItem" type="submit" class="btn btn-default w-150px">{{ $t('str.btn.new.form') }}</button>
                </div>
            </div>

            <vue-good-table
                :columns="columns"
                :rows="items"
                :lineNumbers="true"
                @on-row-click="selectItem"
                :search-options="{ enabled: true, placeholder: $t('str.table.search.in.this.table') }"
                :pagination-options="paginationOptions"
                :totalRows="totalItems"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"
                tableLayout="fixed"
            >
                <div slot="emptystate" class="vgt-center-align vgt-text-disabled">
                    <i v-if="isLoading" class="fas fa-spinner fa-spin" />
                    <span v-if="!isLoading && items?.length === 0">{{ $t('str.table.subtitle.no.data') }}</span>
                </div>
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'address'">
                        {{
                            props.formattedRow[props.column.field].address +
                            ' ' +
                            props.formattedRow[props.column.field].number +
                            ', ' +
                            props.formattedRow[props.column.field].neighborhood +
                            ', ' +
                            props.formattedRow[props.column.field].city +
                            '- ' +
                            props.formattedRow[props.column.field].state
                        }}
                    </span>
                    <span v-else-if="props.column.field === 'createDate'">
                        {{ formatDate(props.formattedRow[props.column.field]) }}
                    </span>
                    <span v-else-if="props.column.field === 'status'">
                        <span class="badge" v-bind:class="props.formattedRow[props.column.field] === 'ACTIVE' ? 'bg-success' : 'bg-danger'"> {{ $t(props.formattedRow[props.column.field]) }} </span>
                    </span>
                    <span v-else-if="props.column.field === 'account'">
                        {{ props.formattedRow[props.column.field].name }}
                    </span>
                    <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </span>
                </template>
            </vue-good-table>
        </panel>
        <ClientModal :selectedData="data" />
        <notifications group="bottom-right" position="bottom right" :speed="500" />
    </div>
</template>

<script>
import Controller from './CrtListClient.vue'
import ClientModal from './Client.vue'
import { client } from '../../../types/client'
import serverPaginationMixin from '../../../utils/serverPaginationMixin'
import { resolveUserSubtype } from '../../../utils/auth'
import Vue from 'vue'
Vue.prototype.$registerEvent = new Vue()

export default {
    mixins: [serverPaginationMixin],
    components: {
        ClientModal,
    },
    data() {
        return {
            items: [],
            isSuperAdminMaster: false,
            isLoading: false,
            filters: {
                account: '',
                type: 'CLIENT',
                status: 'ACTIVE',
                name: '',
            },
            data: {},
            accounts: [],
            clientObj: JSON.parse(JSON.stringify(client)),
            columns: [],
            paginationOptions: {},
        }
    },
    computed: {
        canCreateClient() {
            return ['SUPER_ADMIN_MASTER', 'ADMIN_MASTER', 'GROUP_ADMIN', 'ADMIN'].includes(resolveUserSubtype(this.$session.get('user')))
        },
    },
    mounted() {
        Controller.init(this)
    },
    created() {
        let state = this
        this.$registerEvent.$on('refreshList', function () {
            state.filter()
        })
        this.$registerEvent.$on('changeLanguage', function () {
            state.initTable()
        })
    },
    methods: Controller.methods,
}
</script>
